import React from 'react'

const TableLoader = ({ title = "Loading data..." }) => {
  return (
    <div className="w-full py-12 px-4">
      <div className="max-w-md mx-auto">
        {/* Animated skeleton rows */}
        <div className="space-y-3 mb-6">
          {[1, 2, 3].map((row) => (
            <div key={row} className="flex gap-3 animate-pulse">
              <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-1/4 bg-[length:200%_100%] animate-[shimmer_1.5s_ease-in-out_infinite]"></div>
              <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-2/4 bg-[length:200%_100%] animate-[shimmer_1.5s_ease-in-out_infinite]" style={{ animationDelay: '0.1s' }}></div>
              <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-1/4 bg-[length:200%_100%] animate-[shimmer_1.5s_ease-in-out_infinite]" style={{ animationDelay: '0.2s' }}></div>
            </div>
          ))}
        </div>

        {/* Loading text with animated dots */}
        <div className="flex items-center justify-center gap-2 text-gray-600">
          <div className="relative">
            <div className="w-2 h-2 rounded-full bg-blue-500 animate-bounce"></div>
          </div>
          <div className="relative" style={{ animationDelay: '0.1s' }}>
            <div className="w-2 h-2 rounded-full bg-blue-500 animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          </div>
          <div className="relative" style={{ animationDelay: '0.2s' }}>
            <div className="w-2 h-2 rounded-full bg-blue-500 animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
          <span className="ml-2 text-sm font-medium">{title}</span>
        </div>
      </div>

      <style jsx>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
      `}</style>
    </div>
  )
}

export default TableLoader